// CoffeeScript → JavaScript conversion of nested_form_fields gem v0.8.4
window.nested_form_fields = window.nested_form_fields || {};

nested_form_fields.bind_nested_forms_links = function () {
  $("body").off("click", ".add_nested_fields_link");
  $("body").on("click", ".add_nested_fields_link", function (event, additional_data) {
    const $link = $(this);
    const object_class = $link.data("object-class");
    const association_path = $link.data("association-path");
    const added_index = $(".nested_" + association_path).length;

    $.event.trigger("fields_adding.nested_form_fields", {
      object_class,
      added_index,
      association_path,
      additional_data,
    });

    const $template = $link.data("scope")
      ? $($link.data("scope") + " #" + association_path + "_template")
      : $("#" + association_path + "_template");
    const target = $link.data("insert-into");

    let template_html = $template.html();
    const index_placeholder = "__" + association_path + "_index__";
    template_html = template_html.replace(new RegExp(index_placeholder, "g"), added_index);
    template_html = template_html.replace(new RegExp("__nested_field_for_replace_with_index__", "g"), added_index);

    const $parsed_template = $(template_html);
    $parsed_template.closestChild(".form_template").each(function () {
      const $child = $(this);
      $child.replaceWith(
        $("<script id='" + $child.attr("id") + "' type='text/html' />").html($child.html())
      );
    });

    if (target != null) {
      $("#" + target).append($parsed_template);
    } else {
      $template.before($parsed_template);
    }
    $parsed_template.trigger("fields_added.nested_form_fields", {
      object_class,
      added_index,
      association_path,
      event,
      additional_data,
    });
    return false;
  });

  $("body").off("click", ".remove_nested_fields_link");
  $("body").on("click", ".remove_nested_fields_link", function () {
    const $link = $(this);
    if (!($.rails === undefined || $.rails.allowAction($link))) return false;
    if ($link.attr("disabled")) return false;

    const object_class = $link.data("object-class");
    const delete_association_field_name = $link.data("delete-association-field-name");
    const removed_index = parseInt(
      delete_association_field_name.match("(\\d+\\]\\[_destroy])")[0].match("\\d+")[0]
    );

    $.event.trigger("fields_removing.nested_form_fields", {
      object_class,
      delete_association_field_name,
      removed_index,
    });

    const $nested_fields_container = $link.parents(".nested_fields").first();
    const delete_field = $nested_fields_container.find(
      "input[type='hidden'][name='" + delete_association_field_name + "']"
    );

    if (delete_field.length > 0) {
      delete_field.val("1");
    } else {
      $nested_fields_container.before(
        "<input type='hidden' name='" + delete_association_field_name + "' value='1' />"
      );
    }
    $nested_fields_container.hide();
    $nested_fields_container
      .find("input[required]:hidden, select[required]:hidden, textarea[required]:hidden")
      .removeAttr("required");
    $nested_fields_container.trigger("fields_removed.nested_form_fields", {
      object_class,
      delete_association_field_name,
      removed_index,
    });
    return false;
  });
};

jQuery(function () {
  nested_form_fields.bind_nested_forms_links();
});

// jquery.closestchild 0.1.1 by Andrey Mikhaylov (lolmaus@gmail.com)
$.fn.closestChild = function (selector) {
  const $children = this.children();
  if ($children.length === 0) return $();
  const $results = $children.filter(selector);
  return $results.length > 0 ? $results : $children.closestChild(selector);
};
